var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowR = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50737 4.51197L1.46049 7.55884C1.35594 7.66339 1.22899 7.71567 1.07963 7.71567C0.930276 7.71567 0.803323 7.66339 0.698774 7.55884L0.205897 7.04356C0.101347 6.93901 0.0490722 6.81206 0.0490722 6.6627C0.0490722 6.51335 0.101347 6.38639 0.205897 6.28184L2.35663 4.13111L0.205896 1.98037C0.101347 1.87582 0.049072 1.74887 0.049072 1.59951C0.049072 1.45016 0.101347 1.3232 0.205896 1.21866L0.698773 0.703375C0.803323 0.598825 0.930276 0.54655 1.07963 0.54655C1.22899 0.54655 1.35594 0.598825 1.46049 0.703375L4.50737 3.75025C4.61192 3.8548 4.66419 3.98175 4.66419 4.13111C4.66419 4.28047 4.61192 4.40742 4.50737 4.51197Z",
    fill: "#00A8E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowR, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowR.3d7e3609.svg";
export { ForwardRef as ReactComponent };